import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as LabelPrimitive from "@radix-ui/react-label";
import { forwardRef } from "react";
import { cn } from "../lib/cn";
export const Label = forwardRef(function Label({ className, children, optional = false, optionalLabel, ...props }, ref) {
    return (_jsxs(LabelPrimitive.Root, { ref: ref, className: cn("text-sm font-medium text-primary select-none", "peer-disabled:cursor-not-allowed peer-disabled:opacity-50", className), ...props, children: [children, optional && optionalLabel !== undefined ? (_jsx("span", { "aria-hidden": "true", className: "ms-1 font-normal text-muted", children: optionalLabel })) : null] }));
});
Label.displayName = "Label";
//# sourceMappingURL=label.js.map